<template>
  <div>
    <!-- ABOUT HEADER -->
    <h6 class="display-5 fw-bold text-uppercase mt-5 text-dark" id="contact-me">
      Contact me!
    </h6>
    <!--DIVIDER LINE -->
    <div class="divider-custom">
      <div class="divider-custom-line" />
    </div>
    <contact-body />
  </div>
</template>

<script>
import ContactBody from "./ContactBody.vue";

export default { name: "contact-content", components: { ContactBody } };
</script>

<style scoped>
.divider-custom {
  margin: 0.5rem 0 0.5rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.divider-custom .divider-custom-line {
  width: 100%;
  max-width: 10rem;
  height: 0.1rem;
  background-color: #222831;
  border-radius: 0.25rem;
  border-color: #222831 !important;
}
</style>